import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import translate from './TranslateHOC';
import { PATH_PARENT } from '../constants';
import { isSignInUp } from '../helpers';
import { Icon as IconV2 } from '../v2/components/icon/Icon';
import { device, convertWidth } from '../v2/Theme';
import { fetchSideNav } from '../actions';

function Footer({ auth, strings, isSideNavToggled }) {
  //const [appLinkShow, setAppLinkShow] = useState(true);
  let footerEl = null;

  const setFooterRef = (element) => {
    footerEl = element; // reference to the footer element
  };

  const checkFooterPosition = () => {
    if (footerEl) {
      // get the height of the footer
      const footerHeight = footerEl.getClientRects()?.[0]?.height || 0;

      // get the header height too
      const headerHeight = document.querySelector('.header');

      // get the pageConentEl and apply a 100vh min-height minus the height of the footer and header
      // which will always force the footer to the bottom of the page
      const pageContentEl = document.querySelector('.page-content');
      if (headerHeight) {
        pageContentEl.style.minHeight = `calc(100vh - ${
          footerHeight + headerHeight.offsetHeight
        }px`;
      }
    }
  };

  useEffect(() => {
    checkFooterPosition();
  });

  return (
    <FooterContainer
      ref={setFooterRef}
      isSignInUp={isSignInUp}
      navClosed={!isSideNavToggled}
      navOpen={isSideNavToggled}
    >
      <FooterInner isSignInUp={isSignInUp}>
        {isSignInUp && <ClicFooterDivider isSignInUp={isSignInUp} />}
        <FooterLinksClicContainer>
          <UL>
            {auth && (
              <LI>
                <Link to={PATH_PARENT}>{strings.parentalControl}</Link>
              </LI>
            )}
            <LI>
              <a href={strings.howToWatchLink}>{strings.howToWatch}</a>
            </LI>
          </UL>
          <UL>
            <LI>
              <a
                href="https://www.facebook.com/S4C"
                target="_blank"
                rel="noreferrer"
                aria-label={strings.followS4CFacebook}
              >
                <IconV2 type="custom" customLabel="facebook" />
              </a>
            </LI>
            <LI>
              <a
                href="https://www.instagram.com/s4c/"
                target="_blank"
                rel="noreferrer"
                aria-label={strings.followS4CInstagram}
              >
                <IconV2 type="custom" customLabel="instagram" />
              </a>
            </LI>
            <LI>
              <a
                href="https://twitter.com/S4C"
                target="_blank"
                rel="noreferrer"
                aria-label={strings.followS4CTwitter}
              >
                <IconV2 type="custom" customLabel="twitter" />
              </a>
            </LI>
            <LI>
              <a
                href="https://www.youtube.com/c/S4C"
                target="_blank"
                rel="noreferrer"
                aria-label={strings.followS4CYoutube}
              >
                <IconV2 type="custom" customLabel="youtube" />
              </a>
            </LI>
          </UL>
        </FooterLinksClicContainer>
        <FooterLinksS4CContainer>
          <FooterLinksS4C>
            <UL>
              <LI>
                <a href={strings.s4cHomeLink}>{strings.s4cHome}</a>
              </LI>
              <LI>
                <a href={strings.exploreS4cLink}>{strings.exploreS4c}</a>
              </LI>
              <LI>
                <a href={strings.listingsLink}>{strings.listings}</a>
              </LI>
              <LI>
                <a href={strings.searchS4cLink}>{strings.searchS4c}</a>
              </LI>
              <LI>
                <a href={strings.contactUsLink}>{strings.contactUs}</a>
              </LI>
            </UL>
          </FooterLinksS4C>
          <FooterLinksS4C>
            <UL>
              <LI>
                <a href={strings.aboutThisSiteLink}>{strings.aboutThisSite}</a>
              </LI>
              <LI>
                <a href={strings.accessibilityLink}>{strings.accessibility}</a>
              </LI>
              <LI>
                <a href={strings.privacyPolicyLink}>{strings.privacyPolicy}</a>
              </LI>
              <LI>
                <a href={strings.cookiesLink}>{strings.cookies}</a>
              </LI>
              <LI>
                <a href={strings.termsConditionsLink}>
                  {strings.termsConditions}
                </a>
              </LI>
            </UL>
          </FooterLinksS4C>
          <FooterLinkS4C3>
            <UL>
              <LI>
                <a href={strings.aboutS4cLink}>{strings.aboutS4c}</a>
              </LI>
              <LI>
                <a href={strings.s4cAuthorityLink}>{strings.s4cAuthority}</a>
              </LI>
              <LI>
                <a href={strings.diversityLink}>{strings.diversity}</a>
              </LI>
              <LI>
                <a href={strings.s4cAdvertisingLink}>
                  {strings.s4cAdvertising}
                </a>
              </LI>
              <LI>
                <a href={strings.jobsLink}>{strings.jobs}</a>
              </LI>
              <LI>
                <a href={strings.takePartLink}>{strings.takePart}</a>
              </LI>
            </UL>
          </FooterLinkS4C3>
        </FooterLinksS4CContainer>
      </FooterInner>
    </FooterContainer>
  );
}

const FooterContainer = styled.footer`
  width: 100%;
  ${(props) =>
    props.navOpen &&
    `
    @media ${device.tablet} {
      margin-left: 96px;
    }
    @media screen and (min-width: 1024px) {
      margin-left: 324px;
    }
  `};
  ${(props) =>
    props.navClosed &&
    `
    @media ${device.tablet} {
      margin-left: 96px;
    }
    @media screen and (min-width: 1024px) {
      margin-left: 96px;
    }
  `};
  a {
    ${(props) => props.theme.fontBook};
    font-size: 16px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.black75
        : props.theme.color.white75};
    span {
      background-color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
      &:hover {
        background-color: ${(props) =>
          props.theme.name === 'light'
            ? props.theme.color.blackFull
            : props.theme.color.whiteFull};
      }
    }
    &:hover {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.blackFull
          : props.theme.color.whiteFull};
      span {
        background-color: ${(props) =>
          props.theme.name === 'light'
            ? props.theme.color.blackFull
            : props.theme.color.whiteFull};
      }
    }
    &:focus-visible {
      box-shadow: 0px 0px 0px 2px
        ${(props) =>
          props.theme.name === 'light'
            ? props.theme.color.statusLightFocus
            : props.theme.color.statusDarkFocus};
      border-radius: 4px;
      outline: none;
    }
  }
  ${(props) =>
    props.isSignInUp &&
    `
    @media ${device.desktop} {
      margin-left: 162px !important;
    }
    @media ${device.widest} {
      margin-left: 324px !important;
  `};
`;
const FooterInner = styled.div`
  ${(props) => props.theme.clearFix};
  margin: auto;
  padding: 20px 15px 45px;
  @media ${device.tablet} {
    padding: 36px 0 112px;
    ${(props) =>
      props.isSignInUp
        ? `margin: auto !important; padding-top: 0; max-width: none;`
        : `max-width: none;`};
  }
  @media ${device.desktop} {
    ${(props) => (props.isSignInUp ? `max-width: none;` : `max-width: none;`)};
  }
`;

const UL = styled.ul`
  margin: 0;
  padding: 0;
`;

const LI = styled.li`
  display: inline-block;
  margin-right: 24px;
  padding: 0;
  line-height: 24px;
  list-style: none;
  ${device.tablet} {
    margin: 0;
    &:last-of-type {
      margin-top: 0 !important;
    }
  }
`;

const FooterLinksClicContainer = styled.div`
  ${UL} ${LI} {
    display: inline;
    margin-right: 15px;
  }
  ${UL} + ${UL} {
    margin-top: 30px;
    ${LI}:first-of-type {
      margin-right: 10px;
    }
    ${LI}:not(:first-of-type) {
      margin-right: 22px;
    }
  }
  ${UL}:last-of-type {
    display: flex;
    align-items: center;
    ${LI} a {
      display: flex;
      align-self: center;
    }
  }
  @media ${device.tablet} {
    margin-bottom: 22px;
    padding-bottom: 22px;
  }
  @media screen and (min-width: 1270px) {
    ${UL} ${LI} {
      margin-right: 25px;
    }
  }
`;

const FooterLinksS4CContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.tablet} {
    flex-direction: row;
    ${UL} {
      display: block;
    }
    ${LI} {
      width: 100%;
      line-height: 36px;
    }
  }
`;

const FooterLinksS4C = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${convertWidth(300, 15)};
  width: 100%;
  &:before {
    box-shadow: inset 0 1px 0 0
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black10
          : props.theme.color.white10};
    display: block;
    width: 100%;
    height: 1px;
    margin: 20px 0;
    content: '';
  }

  ${LI}:last-of-type {
    margin-top: 6px;
  }

  @media ${device.tablet} {
    display: block;
    float: left;
    margin-right: ${convertWidth(1245, 15)};
    width: ${convertWidth(1245, 300)};
    &:before {
      content: none;
    }
    ${LI}:last-of-type {
      margin-top: 0;
    }
  }
  @media screen and (min-width: 1270px) {
    width: ${convertWidth(1245, 212)};
  }
`;

const FooterLinkS4C3 = styled(FooterLinksS4C)`
  @media screen and (max-width: 767px) {
    margin-right: 0;
  }
`;

const ClicFooterDivider = styled.div`
  padding-top: 36px;
  ${(props) =>
    props.theme.name === 'light'
      ? 'border-top: 1px solid #E7E7E7'
      : 'border-top: 1px solid #343432'};
`;

function mapStateToProps(state) {
  return {
    auth: state.auth.authenticated,
    isSideNavToggled: state.sideNav,
  };
}

//export default translate (Footer);
export default translate(connect(mapStateToProps, fetchSideNav)(Footer));
